<template>
  <el-dialog title="装备导入" :visible.sync="peiZhuangImportDialog" width="700px" :close-on-click-modal="false"
    :before-close="close" :open="open" v-loading="game.fullScreenLock" element-loading-text="拼命加载中">
    <div style="width: 100%;">
      <el-tabs v-model="activeName" @tab-click="handleClick">

        <el-tab-pane label="游戏导入" name="first" style="font-size: 22px;">
          <div>
            <div>
              <el-form ref="gameFormRef" :disabled="false" :model="game" :rules="game.gameRules"
                style="display:  flex;margin-bottom: 10px;">
                <el-form-item prop="serverKey" style="margin-left: 20px;">
                  <el-cascader v-model="game.serverKey" :options="game.serverTree" @change="() => {
                  }" clearable data-v-step="2">
                  </el-cascader>
                </el-form-item>
                <el-form-item style="margin-left: 10px;">
                  <el-select v-model="game.queryType.queryTypeValue" placeholder="请选择查询方式">
                    <el-option v-for="item in game.queryType.queryTypeList" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="queryTypeCondition" style="margin-left: 10px;" data-v-step="3">
                  
                  <el-input v-if="game.queryType.queryTypeValue === 'roleName'" placeholder="猜猜我是谁" v-model="game.queryTypeCondition" clearable>
                  </el-input>
                  <el-input v-if="game.queryType.queryTypeValue === 'roleId'" placeholder="22662042" v-model="game.queryTypeCondition" clearable>
                  </el-input>
                  </el-form-item>
                <el-form-item style="margin-left: 10px;">
                  <el-button type="primary" @click="gameImportData" data-v-step="4">查询</el-button>
                </el-form-item>
              </el-form>
              <GeeTest ref="geeTestRef" style="margin-top: 10px;"></GeeTest>
            </div>
            <!-- <div>
              <div style="font-size: 14px;">
                因为角色查询接口暂时不可用，查询方式改为采用角色id进行,示意图如下：
                <br />  
                在组队界面按住键位ctrl鼠标移至自身角色下面，即可获取角色ID。
              </div>
              <img src="@/assets/角色导入示意图.png" alt="">
            </div> -->
            <!-- <div v-if="game.role.roleName">
              <UserData :role="game.role" @gameImportData="gameImportData"></UserData>
            </div> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="魔盒导入" name="second" style="font-size: 22px;">
          <div style="padding: auto;height:100%;margin-top: 20px;">
            <el-input type="textarea" v-model="mohe.importData" rows="8" resize="none"
              style="width: 355px;margin-right: 10px;"></el-input>
            <el-button type="primary" @click="moHeImportData">魔盒导入</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>
<script>
import UserData from "./UserData.vue";
import GeeTest from "@/components/utils/geetest/GeeTest.vue";

export default {
  components: {
    UserData,
    GeeTest
  },
  data() {
    return {
      peiZhuangImportDialog: false,
      activeName: 'first',
      mohe: {
        importData: null
      },
      game: {
        importData: null,
        serverKey: null,
        serverTree: [
          {
            value: "wait",
            label: "加载中请稍等"
          }
        ],
        queryType: {
          queryTypeValue: "roleName",
          queryTypeList: [
            { value: "roleName", label: "角色名" },
            { value: "roleId", label: "角色ID" },
          ]
        },
        // 查询条件
        queryTypeCondition: null,
        roleName: null,
        roleId: null,
        role: {
          roleName: null,
          bodyName: null,
          serverName: null,
          zoneName: null,
          forceName: null
        },
        gameRules: {
          serverKey: {
            required: true,
            message: '请选择区服',
            trigger: 'blur'
          },
          queryTypeCondition: {
            required: true,
            message: '请填写查询条件',
            trigger: 'blur'
          }
        },
        fullScreenLock: false
      },
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async open() {
      this.peiZhuangImportDialog = true;
      // 获取服务器数据
      const { data: response } = await this.$http.get("/peiZhuang/import/getServerTree")
      this.game.serverTree = response.data;
    },
    close() {
      this.peiZhuangImportDialog = false;
    },
    // 魔盒导入数据
    moHeImportData() {
      var jsonObject = JSON.parse(this.mohe.importData);
      var req = jsonObject.EquipList;
      this.$emit("moHeImportData", req);
    },
    // 查询角色
    queryRole() {
      this.$refs.gameFormRef.validate(async valid => {
        if (!valid) {
          return;
        }

        const req = {
          server: this.game.serverKey[1],
          name: this.game.roleName
        };

        const { data: response } = await this.$http.post("/peiZhuang/import/getRoleDetail", req)

        if (response.data.roleId == null) {
          this.$alert("该用户不存在，请检查区服或者角色名是否正确");
        }

        this.game.role = response.data;
      })
    },
    // 游戏导入数据
    async gameImportData(arg) {
      this.$refs.gameFormRef.validate(async valid => {
        if (!valid) {
          return;
        }
        let result = this.$refs.geeTestRef.captcha.getValidate();
        if (!result) {
          this.$alert("请先完成验证码验证");
          return;
        }

        this.game.fullScreenLock = true;

        var equips = []
        // 查询装备
        // 访问可乐的角色装备查询接口
        if (this.game.queryType.queryTypeValue == "roleName") {
          try {
            const req = {
              zone: this.game.serverKey[0],
              server: this.game.serverKey[1],
              name: this.game.queryTypeCondition,
              captchaResBo: result
            };
            const { data: response } = await this.$http.post("/peiZhuang/import/getRoleDetail", req)
            equips = response.data.data.Equips;
          } catch {
            this.$refs.geeTestRef.captcha.reset();
            this.$alert("在区服[" + this.game.serverKey[0] + "/" + this.game.serverKey[1] + "]中没有查询到角色名称为[" + this.game.queryTypeCondition + "]的数据，请检查角色名称是否正确！")
          }
        } else if (this.game.queryType.queryTypeValue == "roleId") {
          // 访问推栏的接口
          try {
            const req = {
              zone: this.game.serverKey[0],
              server: this.game.serverKey[1],
              game_role_id: this.game.queryTypeCondition,
              captchaResBo: result
            }
            const { data: response } = await this.$http.post("/peiZhuang/import/getEquipByRoleId", req)
            equips = response.data.Equips;
          } catch {
            this.$refs.geeTestRef.captcha.reset();
            this.$alert("在区服[" + this.game.serverKey[0] + "/" + this.game.serverKey[1] + "]中没有查询到角色ID为[" + this.game.queryTypeCondition + "]的数据，请检查角色ID是否正确！")
          }
        }
        // 如果装备为空直接退出
        if(equips == null || equips.length == 0){
          this.game.fullScreenLock = false;
          return;
        }
        var moHeReq = {
          HAT: this.buildMoHeReq(equips, 4),
          BELT: this.buildMoHeReq(equips, 8),
          SHOES: this.buildMoHeReq(equips, 11),
          WRIST: this.buildMoHeReq(equips, 12),
          JACKET: this.buildMoHeReq(equips, 3),
          RING_1: this.buildMoHeReq(equips, 6),
          RING_2: this.buildMoHeReq(equips, 7),
          BOTTOMS: this.buildMoHeReq(equips, 10),
          PENDANT: this.buildMoHeReq(equips, 9),
          NECKLACE: this.buildMoHeReq(equips, 5),
          PRIMARY_WEAPON: this.buildMoHeReq(equips, 0),
          SECONDARY_WEAPON: this.buildMoHeReq(equips, 2),
        }
        this.peiZhuangImportDialog = false;
        this.game.fullScreenLock = false;
        // 重置验证码
        this.$refs.geeTestRef.captcha.reset();
        this.$emit("moHeImportData", moHeReq);
      });


    },
    // 将推栏装备变成魔盒装备请求格式
    buildMoHeReq(equips, ucPos) {
      var moheReq = {};
      for (var equip of equips) {
        if (equip.UcPos == ucPos) {
          moheReq.id = equip.ID;
          if (equip.effectColorStone != null) {
            moheReq.stone = equip.effectColorStone.ID;
          }
          if (equip.WPermanentEnchant != null) {
            moheReq.enhance = equip.WPermanentEnchant.ID;
          }
          if (equip.WCommonEnchant != null) {
            moheReq.enchant = equip.WCommonEnchant.ID;
          }
          moheReq.strength = equip.StrengthLevel;
          moheReq.embedding = [];
          if (equip.FiveStone != null) {
            for (var fiveStone of equip.FiveStone) {
              moheReq.embedding.push(fiveStone.Level);
            }
          }
          break;
        }
      }
      return moheReq;
    },
    openFullScreenLock() {

    }
  }
};
</script>

<style lang="less" scoped>
/deep/ #tab-first {
  font-size: 18px;
}

/deep/ #tab-second {
  font-size: 18px;
}



/deep/ .el-loading-mask {
  opacity: 0.8;
}

/deep/ .el-loading-spinner {
  /* 图片替换为你自定义的即可 */
  background: url('/src/assets/加载图标.gif') no-repeat;
  // background-size: 1cap 60px;
  // width: 100%;
  // height: 100%;
  // position: relative;
  top: 45%;
  left: 45%;

  .circular {
    width: 42px;
    height: 42px;
    animation: loading-rotate 2s linear infinite;
    display: none;
  }

  .el-loading-text {
    margin-top: 80px;
    margin-left: 45px;
    text-align: left
  }

  .v-tour__target--highlighted {
    // 必须
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.7);
  }
}
</style>
